import React, { useState } from "react";
import { styled } from "@mui/system";
import {
  Avatar,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Typography,
} from "@mui/material";

const StyledIconButton = styled(IconButton)({
  padding: 0,
  "&:hover": {
    backgroundColor: "transparent", // Disable hover color
  },
  "&:hover .MuiAvatar-root": {
    borderColor: "#A3B59C", // Your desired hover border color
  },
});

const StyledAvatar = styled(Avatar)({
  // backgroundColor: "rgb(200, 210, 214)",
  background: "linear-gradient(270deg, #808E7D 0%, #495941 100%)",
  borderWidth: "4px",
  borderRadius: "50%",
  // borderColor: "rgba(255, 255, 255, 0.2)",
  borderColor: "#768371",
  borderStyle: "solid",
  cursor: "pointer",
  width: "56px",
  height: "56px",
  fontSize: "24px",
  fontWeight: "500",
  color: "rgba(255, 255, 255, 1)",
});

const ExpandingWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  flexDirection: "row-reverse",
  position: "relative",
  zIndex: 1000,
  height: 60, // Match avatar height
});

const ExpandingContent = styled("div")<{ open: boolean }>(({ open }) => ({
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  // borderRadius: "20px",
  borderTopLeftRadius: "20px",
  borderBottomLeftRadius: "20px",
  overflow: "hidden",
  transition: "all 0.3s ease-in-out",
  width: open ? "auto" : "0",
  opacity: open ? 1 : 0,
  visibility: open ? "visible" : "hidden",
  marginLeft: "-28px",
  marginRight: "0",
  padding: open ? "0 32px" : "0",
  height: 60, // Match avatar height
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  justifyContent: "flex-start",
}));

const StyledListItem = styled(ListItem)({
  padding: "4px 8px",
  margin: "0",
  whiteSpace: "nowrap",
});

interface UserAccountProps {
  userInitial?: string;
  onLogout: () => void;
}

const UserAccount: React.FC<UserAccountProps> = ({
  userInitial,
  onLogout,
}) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleLogout = () => {
    onLogout();
    setOpen(false);
  };

  return (
    <ExpandingWrapper>
      <StyledIconButton onClick={handleClick}>
        <StyledAvatar>{userInitial}</StyledAvatar>
      </StyledIconButton>
      <ExpandingContent open={open} onClick={handleClick}>
        <List>
          <StyledListItem onClick={handleLogout}>
            <ListItemText
              primary={
                <Typography
                  style={{ color: "rgba(30, 30, 30, 1)", fontWeight: "bold" }}
                >
                  Logout
                </Typography>
              }
            />
          </StyledListItem>
        </List>
      </ExpandingContent>
    </ExpandingWrapper>
  );
};

export default UserAccount;
